import React from 'react';

import BaseBiointelligentLinkFieldModal, {
  BiointelligentLinkFieldModalProps,
} from './BaseBiointelligentLinkFieldModal';

export const TRANSLATION_LINK_NUM_LONGEST_COMPONENTS_TEMPLATE_ID = 'svdrltmpl_autofilllongesttranslations';
export const TRANSLATION_LINK_MAX_LENGTH_TEMPLATE_ID = 'svdrltmpl_autofillmaxtranslationlength';
export const TRANSLATION_LINK_MIN_LENGTH_TEMPLATE_ID = 'svdrltmpl_autofillmintranslationlength';

export default function TranslationLinkFieldModal({
  schemaField,
  onRequestSubmit,
  onRequestClose,
  enableMultiSelectOption,
}: BiointelligentLinkFieldModalProps): JSX.Element {
  return (
    <BaseBiointelligentLinkFieldModal
      schemaField={schemaField}
      componentName="translations"
      residueName="residue"
      numLongestComponentsTemplateId={TRANSLATION_LINK_NUM_LONGEST_COMPONENTS_TEMPLATE_ID}
      maxLengthTemplateId={TRANSLATION_LINK_MAX_LENGTH_TEMPLATE_ID}
      minLengthTemplateId={TRANSLATION_LINK_MIN_LENGTH_TEMPLATE_ID}
      onRequestSubmit={onRequestSubmit}
      onRequestClose={onRequestClose}
      enableMultiSelectOption={enableMultiSelectOption}
    />
  );
}
